module.exports = __webpack_public_path__ + "assets/76c5301fe39545cd910798664aba0466.png";